var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: { "show-error": false, "error-message-align": "right" },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "flowNo",
                    expression: "'flowNo'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("flowNo"),
                  rules: _vm.getRules("flowNo"),
                  label: "编号",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.formData.flowNo,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "flowNo", $$v)
                  },
                  expression: "formData.flowNo",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxry",
                    expression: "'bxry'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("bxry"),
                  name: "flowName",
                  label: "报销人",
                  placeholder: "报销人",
                  "input-align": "right",
                  rules: _vm.getRules("bxry"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            treeData: _vm.deptUserTreeAll.data,
                            value: _vm.formData.bxry,
                            placeholder: "请选择报销人",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.deptUserTreeAll,
                                "bxry"
                              )
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.deptUserTreeAll.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                              },
                              expression: "deptUserTreeAll.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择报销人",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.deptUserTreeAll.show = false
                                },
                                "click-right": _vm.handlePopupSubmit,
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.treeSearch($event, _vm.$refs.tree)
                                },
                              },
                              model: {
                                value: _vm.deptUserTreeAll.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.deptUserTreeAll,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "deptUserTreeAll.filterText",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "h-vh-35",
                                staticStyle: { "overflow-y": "auto" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-10" },
                                  [
                                    _c("el-tree", {
                                      ref: "tree",
                                      attrs: {
                                        "node-key": "uuid",
                                        "check-strictly": "",
                                        data: _vm.deptUserTreeAll.data,
                                        "filter-node-method": _vm.filterNode,
                                        "check-on-click-node": "",
                                        "show-checkbox": "",
                                      },
                                      on: {
                                        "check-change": function ($event) {
                                          return _vm.singleChoice(
                                            $event,
                                            _vm.$refs.tree
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.bxry,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bxry", $$v)
                  },
                  expression: "formData.bxry",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sqr",
                    expression: "'sqr'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("sqr"),
                  name: "flowName",
                  label: "申请人",
                  placeholder: "申请人",
                  "input-align": "right",
                  rules: _vm.getRules("sqr"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.sqr,
                            placeholder: "请选择申请人",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.sqr,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sqr", $$v)
                  },
                  expression: "formData.sqr",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssbm",
                    expression: "'ssbm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssbm",
                  required: _vm.isRequired("ssbm"),
                  value: _vm.formData.ssbm,
                  label: "部门",
                  rules: _vm.getRules("ssbm"),
                  placeholder: "请选择部门",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssbm,
                            placeholder: "请选择部门",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssbm, "ssbm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssbm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssbm, "show", $$v)
                              },
                              expression: "ssbm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择部门",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssbm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("ssbm", {
                                    label: "label",
                                    value: "value",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssbm,
                                    "label"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssbm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssbm, "filterText", $$v)
                                },
                                expression: "ssbm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssbm",
                              attrs: {
                                "value-key": "label",
                                columns: _vm.ssbm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssbm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "hsgs",
                    expression: "'hsgs'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "hsgs",
                  value: _vm.formData.hsgs,
                  rules: _vm.getRules("hsgs"),
                  label: "核算公司",
                  placeholder: "请选择核算公司",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.hsgs,
                            placeholder: "请选择核算公司",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.hsgs, "hsgs")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.hsgs.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.hsgs, "show", $$v)
                              },
                              expression: "hsgs.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择核算公司",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.hsgs.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmit("hsgs", {
                                    label: "name",
                                    value: "id",
                                  })
                                },
                              },
                            }),
                            _c("van-picker", {
                              ref: "hsgs",
                              attrs: {
                                duration: 0,
                                "value-key": "name",
                                columns: _vm.hsgs.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.hsgs.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "关联业务",
                  placeholder: "请选择项目/合同",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm.split(",")[1],
                            placeholder: "请选择项目/合同",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目/合同",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.businessSelectFinish("ssxm")
                                },
                              },
                            }),
                            _c(
                              "van-row",
                              {
                                staticClass: "p-r-20",
                                attrs: { type: "flex", align: "center" },
                              },
                              [
                                _c(
                                  "van-col",
                                  { attrs: { span: 18 } },
                                  [
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.ssxm,
                                            "name",
                                            "columnsLabel"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.ssxm.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ssxm, "filterText", $$v)
                                        },
                                        expression: "ssxm.filterText",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "van-col",
                                  { attrs: { span: 6 } },
                                  [
                                    _c(
                                      "van-button",
                                      {
                                        attrs: {
                                          loading: _vm.btnLoading,
                                          "loading-text": "加载中...",
                                          type: "primary",
                                          "native-type": "button",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectMyProjectList(
                                              "",
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("更多项目... ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "columnsLabel",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  label: "成本归属部门",
                  "input-align": "right",
                  readonly: "",
                },
                model: {
                  value: _vm.deptcost,
                  callback: function ($$v) {
                    _vm.deptcost = $$v
                  },
                  expression: "deptcost",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxsy",
                    expression: "'bxsy'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("bxsy"),
                  required: _vm.isRequired("bxsy"),
                  name: "bxsy",
                  rules: _vm.getRules("bxsy"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "报销事由",
                  "show-word-limit": "",
                  placeholder: "请输入报销事由",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.bxsy,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bxsy", $$v)
                  },
                  expression: "formData.bxsy",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "skrfkbz",
                    expression: "'skrfkbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("skrfkbz"),
                  required: _vm.isRequired("skrfkbz"),
                  rules: _vm.getRules("skrfkbz"),
                  name: "skrfkbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "付款备注",
                  "show-word-limit": "",
                  placeholder:
                    "填写付款备注时，避免使用 “福利、劳务费、工资、薪贴、奖金” 等相关表述。",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.skrfkbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "skrfkbz", $$v)
                  },
                  expression: "formData.skrfkbz",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "startFlowDate",
                    expression: "'startFlowDate'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("startFlowDate"),
                  name: "startFlowDate",
                  label: "报销日期",
                  placeholder: "报销日期",
                  "input-align": "right",
                  rules: _vm.getRules("startFlowDate"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.startFlowDate,
                            placeholder: "请选择报销日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.startFlowDate,
                                "startFlowDate"
                              )
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "startFlowDate",
                          attrs: {
                            "min-date": _vm.startFlowDate.minDate,
                            "max-date": _vm.startFlowDate.maxDate,
                            "show-confirm": false,
                            title: "选择报销日期",
                          },
                          on: { confirm: _vm.startFlowDateConfirm },
                          model: {
                            value: _vm.startFlowDate.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.startFlowDate, "show", $$v)
                            },
                            expression: "startFlowDate.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.startFlowDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "startFlowDate", $$v)
                  },
                  expression: "formData.startFlowDate",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fj",
                    expression: "'fj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "fj",
                  required: _vm.isRequired("fj"),
                  rules: _vm.getRules("fj"),
                  label: "附件",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.fj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("fj"),
                            files: _vm.formData.fj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "fj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "papfj",
                    expression: "'papfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "papfj",
                  required: _vm.isRequired("papfj"),
                  rules: _vm.getRules("papfj"),
                  label: "纸质报销凭证",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.papfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("papfj"),
                            files: _vm.formData.papfj,
                            "module-type": "flow",
                          },
                          on: {
                            success: _vm.uploadPapfjSuccess,
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "papfj"
                              ),
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "skrbz",
                    expression: "'skrbz'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("skrbz"),
                  required: _vm.isRequired("skrbz"),
                  rules: _vm.getRules("skrbz"),
                  name: "skrbz",
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "备注",
                  "show-word-limit": "",
                  placeholder: "请输入备注",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.skrbz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "skrbz", $$v)
                  },
                  expression: "formData.skrbz",
                },
              }),
              _c(
                "van-field",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "sfgzbx",
                      expression: "'sfgzbx'",
                    },
                  ],
                  attrs: {
                    center: "",
                    "input-align": "right",
                    required: _vm.isRequired("sfgzbx"),
                    name: "sfgzbx",
                    rules: _vm.getRules("sfgzbx"),
                    label: "是否挂账报销",
                    placeholder: "是否挂账报销",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function () {
                        return [
                          _c("span", [_vm._v("是否挂账报销")]),
                          _c("van-icon", {
                            staticStyle: { color: "red", "margin-left": "5px" },
                            attrs: { name: "question-o" },
                            on: { click: _vm.showGzbxHelpInfo },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "input",
                      fn: function () {
                        return [
                          _vm.isDisabled("sfgzbx")
                            ? _c("view-item", {
                                attrs: {
                                  value: _vm.formData.sfgzbx,
                                  placeholder: "请选择是否挂账报销",
                                },
                              })
                            : _c(
                                "van-radio-group",
                                {
                                  attrs: { direction: "horizontal" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeSfgzbx()
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.sfgzbx,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "sfgzbx", $$v)
                                    },
                                    expression: "formData.sfgzbx",
                                  },
                                },
                                [
                                  _c("van-radio", { attrs: { name: "否" } }, [
                                    _vm._v("否"),
                                  ]),
                                  _c("van-radio", { attrs: { name: "是" } }, [
                                    _vm._v("是"),
                                  ]),
                                ],
                                1
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.formData.sfgzbx,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "sfgzbx", $$v)
                    },
                    expression: "formData.sfgzbx",
                  },
                },
                [_vm._v("~ ")]
              ),
              _c("van-notice-bar", {
                attrs: {
                  scrollable: "",
                  text: "1、借款冲销：请选择要冲销的借款记录，并明确填写冲销金额。如果有现金需要退还给财务，请记得填写相应的现金退还金额。\n2、供应商货款冲销：建议关联相应的付款审批流程。",
                },
              }),
              _c(
                "van-field",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "bxfs",
                      expression: "'bxfs'",
                    },
                  ],
                  attrs: {
                    center: "",
                    "input-align": "right",
                    required: _vm.isRequired("bxfs"),
                    name: "bxfs",
                    rules: _vm.getRules("bxfs"),
                    label: "报销方式",
                    placeholder: "请选择报销方式",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "input",
                      fn: function () {
                        return [
                          _vm.isDisabled("bxfs")
                            ? _c("view-item", {
                                attrs: {
                                  value:
                                    _vm.formData.bxfs == "0"
                                      ? "正常报销"
                                      : _vm.formData.bxfs == "1"
                                      ? "借款冲销"
                                      : "供应商货款冲销",
                                  placeholder: "请选择申请人",
                                },
                              })
                            : _c(
                                "van-radio-group",
                                {
                                  attrs: { direction: "horizontal" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeBxfs()
                                    },
                                  },
                                  model: {
                                    value: _vm.formData.bxfs,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "bxfs", $$v)
                                    },
                                    expression: "formData.bxfs",
                                  },
                                },
                                [
                                  _c(
                                    "van-radio",
                                    {
                                      staticClass: "m-r-20",
                                      attrs: { name: "0" },
                                    },
                                    [_vm._v("正常报销")]
                                  ),
                                  _c(
                                    "van-radio",
                                    {
                                      staticClass: "m-r-20",
                                      attrs: { name: "1" },
                                    },
                                    [_vm._v("借款冲销")]
                                  ),
                                ],
                                1
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.formData.bxfs,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "bxfs", $$v)
                    },
                    expression: "formData.bxfs",
                  },
                },
                [_vm._v("~ ")]
              ),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxfs",
                    expression: "'bxfs'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("debtMoney"),
                  label: "累计借款欠款",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.debtMoney && _vm.formData.debtMoney != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.debtMoney) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.debtMoney && _vm.formData.debtMoney != 0
                            ? _c("span", { staticClass: "p-l-20" }, [
                                _vm._v(" 大写："),
                              ])
                            : _vm._e(),
                          _vm.formData.debtMoney && _vm.formData.debtMoney != 0
                            ? _c("span", { staticClass: "cor-F64646" }, [
                                _vm._v(
                                  _vm._s(_vm.getChinese(_vm.formData.debtMoney))
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.debtMoney,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "debtMoney", $$v)
                  },
                  expression: "formData.debtMoney",
                },
              }),
            ],
            1
          ),
          _c(
            "van-row",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "fpfj",
                  expression: "'fpfj'",
                },
              ],
              staticClass: "m-t-20",
              attrs: { type: "flex", align: "center" },
            },
            [
              _c("van-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "font-32 font-weight-500 cor-00" }, [
                  _vm._v("发票信息"),
                ]),
              ]),
              _c(
                "van-col",
                { attrs: { span: 12 } },
                [
                  !_vm.isDisabled("fpfj") || _vm.formData.fpfj.length <= 50
                    ? _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "上传并识别",
                        },
                        on: { click: _vm.uploadInvoice },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.formData.fpfj.length === 0
            ? _c("van-cell-group", { staticClass: "text-center m-t-20 p-20" }, [
                _c("img", {
                  staticClass: "w-300 h-300",
                  attrs: { src: `${_vm.image_base_url}/null.png` },
                }),
                _c("div", { staticClass: "font-24 cor-8B m-t-20" }, [
                  _vm._v("暂无发票信息~"),
                ]),
              ])
            : _vm._e(),
          _vm._l(_vm.formData.fpfj, function (item, index) {
            return _c(
              "van-cell-group",
              {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "fpfj",
                    expression: "'fpfj'",
                  },
                ],
                key: index,
                staticClass: "b-r-10 m-t-20",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      { attrs: { type: "flex", align: "center" } },
                      [
                        _c("van-col", { attrs: { span: 22 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`明细${index + 1}`))]
                          ),
                        ]),
                        _vm.isShowIcon("fpfj")
                          ? _c(
                              "van-col",
                              {
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "fpfj")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                item.invoiceType == 3
                  ? _c(
                      "div",
                      [
                        _c("van-field", {
                          attrs: {
                            label: "发票抬头",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceTitle,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceTitle", $$v)
                            },
                            expression: "item.invoiceTitle",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "发票号码",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceCode", $$v)
                            },
                            expression: "item.invoiceCode",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "开票日期",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.invoiceDate) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.invoiceDate,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceDate", $$v)
                            },
                            expression: "item.invoiceDate",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.ticketPrice,
                            callback: function ($$v) {
                              _vm.$set(item, "ticketPrice", $$v)
                            },
                            expression: "item.ticketPrice",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "行程信息",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.travelInformation,
                            callback: function ($$v) {
                              _vm.$set(item, "travelInformation", $$v)
                            },
                            expression: "item.travelInformation",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "乘车时间",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.travelTime,
                            callback: function ($$v) {
                              _vm.$set(item, "travelTime", $$v)
                            },
                            expression: "item.travelTime",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "乘车人",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.passenger,
                            callback: function ($$v) {
                              _vm.$set(item, "passenger", $$v)
                            },
                            expression: "item.passenger",
                          },
                        }),
                      ],
                      1
                    )
                  : item.invoiceType == 4
                  ? _c(
                      "div",
                      [
                        _c("van-field", {
                          attrs: {
                            label: "发票抬头",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceTitle,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceTitle", $$v)
                            },
                            expression: "item.invoiceTitle",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "发票号码",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceCode", $$v)
                            },
                            expression: "item.invoiceCode",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "开票日期",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.invoiceDate) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.invoiceDate,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceDate", $$v)
                            },
                            expression: "item.invoiceDate",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "机票金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.ticketPrice,
                            callback: function ($$v) {
                              _vm.$set(item, "ticketPrice", $$v)
                            },
                            expression: "item.ticketPrice",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "燃油附加费",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.fuelFee,
                            callback: function ($$v) {
                              _vm.$set(item, "fuelFee", $$v)
                            },
                            expression: "item.fuelFee",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "民航发展基金",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.civilFund,
                            callback: function ($$v) {
                              _vm.$set(item, "civilFund", $$v)
                            },
                            expression: "item.civilFund",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "合计金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceAmount", $$v)
                            },
                            expression: "item.invoiceAmount",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "出发城市",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.departureStation,
                            callback: function ($$v) {
                              _vm.$set(item, "departureStation", $$v)
                            },
                            expression: "item.departureStation",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "到达城市",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.arriveStation,
                            callback: function ($$v) {
                              _vm.$set(item, "arriveStation", $$v)
                            },
                            expression: "item.arriveStation",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "乘机人",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.passenger,
                            callback: function ($$v) {
                              _vm.$set(item, "passenger", $$v)
                            },
                            expression: "item.passenger",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("van-field", {
                          attrs: {
                            label: "发票抬头",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceTitle,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceTitle", $$v)
                            },
                            expression: "item.invoiceTitle",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "发票号码",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceCode,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceCode", $$v)
                            },
                            expression: "item.invoiceCode",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "开票日期",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(item.invoiceDate) + " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.invoiceDate,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceDate", $$v)
                            },
                            expression: "item.invoiceDate",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "税额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.taxAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "taxAmount", $$v)
                            },
                            expression: "item.taxAmount",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "不含税金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.taxExcludedAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "taxExcludedAmount", $$v)
                            },
                            expression: "item.taxExcludedAmount",
                          },
                        }),
                        _c("van-field", {
                          attrs: {
                            label: "价税合计金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.invoiceAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "invoiceAmount", $$v)
                            },
                            expression: "item.invoiceAmount",
                          },
                        }),
                      ],
                      1
                    ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "fpfj",
                      expression: "'fpfj'",
                    },
                  ],
                  attrs: {
                    "input-align": "right",
                    name: "fpfj",
                    label: "附件",
                    placeholder: "请上传文件",
                  },
                  domProps: { value: item.file.filePath },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            item.file.filePath
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "pdfFormBox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.fpfjClick(item.file)
                                      },
                                    },
                                  },
                                  [
                                    _c("PdfPreview", {
                                      ref: "PdfPreview" + index,
                                      refInFor: true,
                                      attrs: { "pdf-url": item.file.filePath },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ],
              1
            )
          }),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                attrs: {
                  center: "",
                  label: "发票金额合计",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.invoiceAmountTotal && _vm.invoiceAmountTotal != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.invoiceAmountTotal) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.invoiceAmountTotal && _vm.invoiceAmountTotal != 0
                            ? _c("div", [
                                _c("span", { staticClass: "p-l-20" }, [
                                  _vm._v(" 大写："),
                                ]),
                                _c("span", { staticClass: "cor-F64646" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getChinese(_vm.invoiceAmountTotal)
                                    )
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.invoiceAmountTotal,
                  callback: function ($$v) {
                    _vm.invoiceAmountTotal = $$v
                  },
                  expression: "invoiceAmountTotal",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "elecTickets",
                    expression: "'elecTickets'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("elecTickets"),
                  type: "digit",
                  required: _vm.isRequired("elecTickets"),
                  rules: _vm.getRules("pjzselecTickets"),
                  name: "elecTickets",
                  maxlength: "50",
                  autosize: "",
                  label: "电子票据张数",
                  placeholder: "请输入电子票据张数",
                  "input-align": "right",
                },
                on: { blur: _vm.pjzsChange },
                model: {
                  value: _vm.formData.elecTickets,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "elecTickets", $$v)
                  },
                  expression: "formData.elecTickets",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "papTickets",
                    expression: "'papTickets'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("papTickets"),
                  type: "digit",
                  required: _vm.isRequired("papTickets"),
                  rules: _vm.getRules("papTickets"),
                  name: "papTickets",
                  maxlength: "50",
                  autosize: "",
                  label: "纸质票据张数",
                  placeholder: "请输入纸质票据张数",
                  "input-align": "right",
                },
                on: { blur: _vm.pjzsChange },
                model: {
                  value: _vm.formData.papTickets,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "papTickets", $$v)
                  },
                  expression: "formData.papTickets",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "pjzs",
                    expression: "'pjzs'",
                  },
                ],
                attrs: {
                  readonly: "",
                  type: "digit",
                  rules: _vm.getRules("pjzs"),
                  name: "pjzs",
                  maxlength: "50",
                  autosize: "",
                  label: "票据张数",
                  placeholder: "请输入票据张数",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.pjzs,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "pjzs", $$v)
                  },
                  expression: "formData.pjzs",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
            [_vm._v("报销明细")]
          ),
          _vm._l(_vm.formData.bxmxb, function (item, index) {
            return _c(
              "van-cell-group",
              { key: index, staticClass: "b-r-10 m-t-20" },
              [
                _c(
                  "div",
                  {
                    staticClass: "p-b-20",
                    staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                  },
                  [
                    _c(
                      "van-row",
                      { attrs: { type: "flex", align: "center" } },
                      [
                        _c("van-col", { attrs: { span: 22 } }, [
                          _c("img", {
                            staticClass: "w-5 h-28",
                            attrs: {
                              src: `${_vm.image_base_url}/icon_line.png`,
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "cor-33 font-weight-500 font-28 m-l-16",
                            },
                            [_vm._v(_vm._s(`明细${index + 1}`))]
                          ),
                        ]),
                        _vm.isShowIcon("bxmxb")
                          ? _c(
                              "van-col",
                              {
                                attrs: { span: 2 },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "bxmxb")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "bxlx",
                      expression: "'bxlx'",
                    },
                  ],
                  attrs: {
                    name: "bxlx",
                    required: _vm.isRequired("bxlx"),
                    rules: _vm.getRules("bxlx"),
                    label: "报销类型",
                    placeholder: "报销类型",
                    "input-align": "right",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.bxlx,
                                placeholder: "请选择报销类型",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.bxlx.show,
                                    index,
                                    "bxlx"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.bxlx.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.bxlx.show, index, $$v)
                                  },
                                  expression: "bxlx.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择报销类型",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.bxlx.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.bxlxPopupSubmit(item, index)
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.treeSearch(
                                        $event,
                                        _vm.$refs[`bxlxTree_${index}`]
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.bxlx.filterText[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.bxlx.filterText, index, $$v)
                                    },
                                    expression: "bxlx.filterText[index]",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h-vh-35",
                                    staticStyle: { "overflow-y": "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "p-10" },
                                      [
                                        _c("el-tree", {
                                          ref: `bxlxTree_${index}`,
                                          refInFor: true,
                                          attrs: {
                                            "node-key": "id",
                                            "check-strictly": "",
                                            data: _vm.bxlx.data,
                                            "filter-node-method":
                                              _vm.filterNode,
                                            "check-on-click-node": "",
                                            "show-checkbox": "",
                                          },
                                          on: {
                                            "check-change": function ($event) {
                                              return _vm.singleChoice(
                                                $event,
                                                _vm.$refs[`bxlxTree_${index}`],
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.bxlx,
                    callback: function ($$v) {
                      _vm.$set(item, "bxlx", $$v)
                    },
                    expression: "item.bxlx",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "bxje",
                      expression: "'bxje'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("bxje"),
                    type: "number",
                    name: "bxje",
                    rules: _vm.getRules("bxje"),
                    required: _vm.isRequired("bxje"),
                    maxlength: 10,
                    placeholder: "请输入报销金额",
                    label: "报销金额",
                    "input-align": "right",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.formatToTwoDecimals(item, "bxje")
                    },
                  },
                  model: {
                    value: item.bxje,
                    callback: function ($$v) {
                      _vm.$set(item, "bxje", $$v)
                    },
                    expression: "item.bxje",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "fymx",
                      expression: "'fymx'",
                    },
                  ],
                  attrs: {
                    disabled: _vm.isDisabled("fymx"),
                    type: "textarea",
                    name: "fymx",
                    rules: _vm.getRules("fymx"),
                    required: _vm.isRequired("fymx"),
                    maxlength: "200",
                    rows: "3",
                    autosize: "",
                    label: "费用明细",
                    "show-word-limit": "",
                    placeholder: "请输入费用明细",
                    "input-align": "right",
                  },
                  model: {
                    value: item.fymx,
                    callback: function ($$v) {
                      _vm.$set(item, "fymx", $$v)
                    },
                    expression: "item.fymx",
                  },
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "gskm",
                      expression: "'gskm'",
                    },
                  ],
                  attrs: {
                    value: item.gskm,
                    "input-align": "right",
                    name: "gskm",
                    rules: _vm.getRules("gskm"),
                    required: _vm.isRequired("gskm"),
                    label: "归属科目",
                    placeholder: "请选择归属科目",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _c("view-item", {
                              attrs: {
                                value: item.gskm,
                                placeholder: "请选择归属科目",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.popupShow(
                                    _vm.gskm.show,
                                    index,
                                    "gskm"
                                  )
                                },
                              },
                            }),
                            _c(
                              "van-popup",
                              {
                                attrs: { position: "bottom" },
                                model: {
                                  value: _vm.gskm.show[index],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.gskm.show, index, $$v)
                                  },
                                  expression: "gskm.show[index]",
                                },
                              },
                              [
                                _c("van-nav-bar", {
                                  attrs: {
                                    title: "选择归属科目",
                                    "left-text": "取消",
                                    "right-text": "确定",
                                  },
                                  on: {
                                    "click-left": function ($event) {
                                      return _vm.popupHidden(
                                        _vm.gskm.show,
                                        index
                                      )
                                    },
                                    "click-right": function ($event) {
                                      return _vm.gskmSubmit(item, index)
                                    },
                                  },
                                }),
                                _c("van-search", {
                                  attrs: { clearable: "", shape: "round" },
                                  on: {
                                    input: function ($event) {
                                      return _vm.treeSearch(
                                        $event,
                                        _vm.$refs[`gskmTree_${index}`]
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.gskm.filterText,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.gskm, "filterText", $$v)
                                    },
                                    expression: "gskm.filterText",
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "h-vh-35",
                                    staticStyle: { "overflow-y": "auto" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "p-10" },
                                      [
                                        _c("el-tree", {
                                          ref: `gskmTree_${index}`,
                                          refInFor: true,
                                          attrs: {
                                            "node-key": "id",
                                            "check-strictly": "",
                                            data: _vm.gskm.data,
                                            "filter-node-method":
                                              _vm.filterNode,
                                            "check-on-click-node": "",
                                            "show-checkbox": "",
                                          },
                                          on: {
                                            "check-change": function ($event) {
                                              return _vm.singleChoice(
                                                $event,
                                                _vm.$refs[`gskmTree_${index}`],
                                                index
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("van-field", {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "sfxyft",
                      expression: "'sfxyft'",
                    },
                  ],
                  attrs: {
                    center: "",
                    "input-align": "right",
                    required: _vm.isRequired("sfxyft"),
                    name: "sfxyft",
                    rules: _vm.getRules("sfxyft"),
                    label: "是否分摊",
                    placeholder: "请选择是否分摊",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "input",
                        fn: function () {
                          return [
                            _vm.isDisabled("sfxyft")
                              ? _c("div", [_vm._v(_vm._s(item.sfxyft))])
                              : _c(
                                  "van-radio-group",
                                  {
                                    attrs: { direction: "horizontal" },
                                    model: {
                                      value: item.sfxyft,
                                      callback: function ($$v) {
                                        _vm.$set(item, "sfxyft", $$v)
                                      },
                                      expression: "item.sfxyft",
                                    },
                                  },
                                  [
                                    _c(
                                      "van-radio",
                                      {
                                        attrs: { name: "是" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleFt(item)
                                          },
                                        },
                                      },
                                      [_vm._v("是")]
                                    ),
                                    _c(
                                      "van-radio",
                                      {
                                        attrs: { name: "否" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleFt(item)
                                          },
                                        },
                                      },
                                      [_vm._v("否")]
                                    ),
                                  ],
                                  1
                                ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                  model: {
                    value: item.sfxyft,
                    callback: function ($$v) {
                      _vm.$set(item, "sfxyft", $$v)
                    },
                    expression: "item.sfxyft",
                  },
                }),
              ],
              1
            )
          }),
          !_vm.isDisabled("bxmxb")
            ? _c(
                "van-row",
                [
                  _c("van-col", { attrs: { span: 12 } }),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      _c("van-button", {
                        staticClass: "width-100",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "添加报销明细",
                        },
                        on: { click: _vm.addBxItem },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "van-cell-group",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "bxzje",
                  expression: "'bxzje'",
                },
              ],
              staticClass: "m-t-20",
            },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "bxzje",
                    expression: "'bxzje'",
                  },
                ],
                attrs: {
                  center: "",
                  rules: _vm.getRules("bxzje"),
                  required: _vm.isRequired("bxzje"),
                  label: "报销总金额",
                  "input-align": "right",
                  readonly: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm.formData.bxzje && _vm.formData.bxzje != 0
                            ? _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getFormatValue(_vm.formData.bxzje) +
                                      " 元"
                                  ),
                                },
                              })
                            : _c("span", [_vm._v("无")]),
                          _vm.formData.bxzje && _vm.formData.bxzje != 0
                            ? _c("div", [
                                _c("span", { staticClass: "p-l-20" }, [
                                  _vm._v(" 大写："),
                                ]),
                                _c("span", { staticClass: "cor-F64646" }, [
                                  _vm._v(
                                    _vm._s(_vm.getChinese(_vm.formData.bxzje))
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.bxzje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "bxzje", $$v)
                  },
                  expression: "formData.bxzje",
                },
              }),
            ],
            1
          ),
          _vm.formData.bxfs == "1"
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "font-32 font-weight-500 cor-00 m-t-26 m-b-26",
                    },
                    [_vm._v("借款冲销")]
                  ),
                  _c("van-field", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: {
                      value: _vm.formData.byjmxb[0],
                      rules: _vm.getRules("byjmxb"),
                    },
                  }),
                  _vm._l(_vm.formData.byjmxb, function (item, index) {
                    return _c(
                      "van-cell-group",
                      { key: index, staticClass: "b-r-10 m-t-20" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "p-b-20",
                            staticStyle: {
                              "border-bottom": "1px solid #EBEBEB",
                            },
                          },
                          [
                            _c(
                              "van-row",
                              { attrs: { type: "flex", align: "center" } },
                              [
                                _c("van-col", { attrs: { span: 22 } }, [
                                  _c("img", {
                                    staticClass: "w-5 h-28",
                                    attrs: {
                                      src: `${_vm.image_base_url}/icon_line.png`,
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "cor-33 font-weight-500 font-28 m-l-16",
                                    },
                                    [_vm._v(_vm._s(`借款明细${index + 1}`))]
                                  ),
                                ]),
                                _vm.isShowIcon("byjmxb")
                                  ? _c(
                                      "van-col",
                                      {
                                        attrs: { span: 2 },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeItem(
                                              index,
                                              "byjmxb"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "w-30 h-30",
                                          attrs: {
                                            src: `${_vm.image_base_url}/shoppingDel.png`,
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "userName",
                              expression: "'userName'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("userName"),
                            rules: _vm.getRules("userName"),
                            label: "借款人",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.userName,
                            callback: function ($$v) {
                              _vm.$set(item, "userName", $$v)
                            },
                            expression: "item.userName",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "businessNo",
                              expression: "'businessNo'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("businessNo"),
                            rules: _vm.getRules("businessNo"),
                            label: "关联单号",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.businessNo,
                            callback: function ($$v) {
                              _vm.$set(item, "businessNo", $$v)
                            },
                            expression: "item.businessNo",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "debtTime",
                              expression: "'debtTime'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("debtTime"),
                            rules: _vm.getRules("debtTime"),
                            label: "借款时间",
                            "input-align": "right",
                            readonly: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .moment(item.debtTime)
                                            .format("YYYY-MM-DD hh:mm:ss")
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.debtTime,
                            callback: function ($$v) {
                              _vm.$set(item, "debtTime", $$v)
                            },
                            expression: "item.debtTime",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "debtAmount",
                              expression: "'debtAmount'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("debtAmount"),
                            rules: _vm.getRules("debtAmount"),
                            label: "借款金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.debtAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "debtAmount", $$v)
                            },
                            expression: "item.debtAmount",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "repayAmount",
                              expression: "'repayAmount'",
                            },
                          ],
                          attrs: {
                            required: _vm.isRequired("repayAmount"),
                            rules: _vm.getRules("repayAmount"),
                            label: "已还款金额",
                            "input-align": "right",
                            readonly: "",
                          },
                          model: {
                            value: item.repayAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "repayAmount", $$v)
                            },
                            expression: "item.repayAmount",
                          },
                        }),
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "currentRepayAmount",
                              expression: "'currentRepayAmount'",
                            },
                          ],
                          attrs: {
                            disabled: _vm.isDisabled("currentRepayAmount"),
                            type: "number",
                            name: "currentRepayAmount",
                            rules: _vm.getRules("currentRepayAmount"),
                            required: _vm.isRequired("currentRepayAmount"),
                            maxlength: 10,
                            placeholder: "请输入本次冲销金额",
                            label: "本次冲销金额",
                            "input-align": "right",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.formatToTwoDecimals(
                                item,
                                "currentRepayAmount"
                              )
                            },
                          },
                          model: {
                            value: item.currentRepayAmount,
                            callback: function ($$v) {
                              _vm.$set(item, "currentRepayAmount", $$v)
                            },
                            expression: "item.currentRepayAmount",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  !_vm.isDisabled("byjmxb")
                    ? _c(
                        "van-row",
                        [
                          _c("van-col", { attrs: { span: 12 } }),
                          _c(
                            "van-col",
                            { attrs: { span: 12 } },
                            [
                              _c("van-button", {
                                staticClass: "width-100",
                                attrs: {
                                  icon: "add-o",
                                  round: "",
                                  "native-type": "button",
                                  color: "#FFDA3E",
                                  text: "添加借款",
                                },
                                on: { click: _vm.addImprest },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "van-cell-group",
                    {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "currentRepayAmountTotal",
                          expression: "'currentRepayAmountTotal'",
                        },
                      ],
                      staticClass: "m-t-20",
                    },
                    [
                      _c("van-field", {
                        directives: [
                          {
                            name: "f-show",
                            rawName: "v-f-show",
                            value: "currentRepayAmountTotal",
                            expression: "'currentRepayAmountTotal'",
                          },
                        ],
                        attrs: {
                          center: "",
                          rules: _vm.getRules("currentRepayAmountTotal"),
                          required: _vm.isRequired("currentRepayAmountTotal"),
                          label: "本次冲销总金额",
                          "input-align": "right",
                          readonly: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm.formData.currentRepayAmountTotal &&
                                    _vm.formData.currentRepayAmountTotal != 0
                                      ? _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.getFormatValue(
                                                _vm.formData
                                                  .currentRepayAmountTotal
                                              ) + " 元"
                                            ),
                                          },
                                        })
                                      : _c("span", [_vm._v("无")]),
                                    _vm.formData.currentRepayAmountTotal &&
                                    _vm.formData.currentRepayAmountTotal != 0
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "p-l-20" },
                                            [_vm._v(" 大写：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "cor-F64646" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getChinese(
                                                    _vm.formData
                                                      .currentRepayAmountTotal
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          970224172
                        ),
                        model: {
                          value: _vm.formData.currentRepayAmountTotal,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formData,
                              "currentRepayAmountTotal",
                              $$v
                            )
                          },
                          expression: "formData.currentRepayAmountTotal",
                        },
                      }),
                      _c("van-field", {
                        directives: [
                          {
                            name: "f-show",
                            rawName: "v-f-show",
                            value: "payCashTotal",
                            expression: "'payCashTotal'",
                          },
                        ],
                        attrs: {
                          center: "",
                          rules: _vm.getRules("payCashTotal"),
                          required: _vm.isRequired("payCashTotal"),
                          label: "本次现金还款总金额",
                          "input-align": "right",
                          readonly: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm.formData.payCashTotal &&
                                    _vm.formData.payCashTotal != 0
                                      ? _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.getFormatValue(
                                                _vm.formData.payCashTotal
                                              ) + " 元"
                                            ),
                                          },
                                        })
                                      : _c("span", [_vm._v("无")]),
                                    _vm.formData.payCashTotal &&
                                    _vm.formData.payCashTotal != 0
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "p-l-20" },
                                            [_vm._v(" 大写：")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "cor-F64646" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getChinese(
                                                    _vm.formData.payCashTotal
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3759350380
                        ),
                        model: {
                          value: _vm.formData.payCashTotal,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "payCashTotal", $$v)
                          },
                          expression: "formData.payCashTotal",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          _vm.formData.bxfs != "2"
            ? _c(
                "div",
                { staticClass: "flex row-between col-center m-t-20" },
                [
                  _c("div", { staticClass: "font-32 font-weight-500 cor-00" }, [
                    _vm._v("收款人账户信息"),
                  ]),
                  !_vm.isDisabled("skrhm")
                    ? _c("van-button", {
                        staticClass: "width-50",
                        attrs: {
                          icon: "add-o",
                          round: "",
                          "native-type": "button",
                          color: "#FFDA3E",
                          text: "选择收款人账户",
                        },
                        on: {
                          click: function ($event) {
                            _vm.account.show = true
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.formData.bxfs != "2"
            ? _c(
                "van-cell-group",
                { staticClass: "m-t-20" },
                [
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "skrhm",
                        expression: "'skrhm'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("skrhm"),
                      required: _vm.isRequired("skrhm"),
                      name: "skrhm",
                      rules: _vm.getRules("skrhm"),
                      maxlength: "50",
                      autosize: "",
                      label: "收款人户名",
                      placeholder: "请输入收款人户名",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.skrhm,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skrhm", $$v)
                      },
                      expression: "formData.skrhm",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "skrkhh",
                        expression: "'skrkhh'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("skrkhh"),
                      required: _vm.isRequired("skrkhh"),
                      rules: _vm.getRules("skrkhh"),
                      name: "skrkhh",
                      maxlength: "50",
                      autosize: "",
                      label: "收款人开户行",
                      placeholder: "请输入收款人开户行",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.skrkhh,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skrkhh", $$v)
                      },
                      expression: "formData.skrkhh",
                    },
                  }),
                  _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "skryhzh",
                        expression: "'skryhzh'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("skryhzh"),
                      required: _vm.isRequired("skryhzh"),
                      rules: _vm.getRules("skryhzh"),
                      name: "skryhzh",
                      maxlength: "50",
                      autosize: "",
                      label: "收款人账号",
                      placeholder: "请输入收款人账号",
                      "input-align": "right",
                    },
                    model: {
                      value: _vm.formData.skryhzh,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "skryhzh", $$v)
                      },
                      expression: "formData.skryhzh",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isContract
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "f-show",
                      rawName: "v-f-show",
                      value: "zcht",
                      expression: "'zcht'",
                    },
                  ],
                },
                [
                  _c(
                    "div",
                    { staticClass: "font-32 font-weight-500 cor-00 m-t-26" },
                    [_vm._v("关联合同")]
                  ),
                  _c(
                    "van-cell-group",
                    { staticClass: "m-t-20" },
                    [
                      _c("van-field", {
                        attrs: {
                          "input-align": "right",
                          name: "zcht",
                          required: _vm.isRequired("zcht"),
                          rules: _vm.getRules("zcht"),
                          value: _vm.formData.zcht,
                          label: "支出合同",
                          placeholder: "请选择支出合同",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  _c("view-item", {
                                    attrs: {
                                      value: _vm.formData.zcht,
                                      placeholder: "请选择支出合同",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.isShowPopup(_vm.zcht, "zcht")
                                      },
                                    },
                                  }),
                                  _c(
                                    "van-popup",
                                    {
                                      attrs: { position: "bottom" },
                                      model: {
                                        value: _vm.zcht.show,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.zcht, "show", $$v)
                                        },
                                        expression: "zcht.show",
                                      },
                                    },
                                    [
                                      _c("van-nav-bar", {
                                        attrs: {
                                          title: "支出合同",
                                          "left-text": "取消",
                                          "right-text": "确定",
                                        },
                                        on: {
                                          "click-left": function ($event) {
                                            _vm.zcht.show = false
                                          },
                                          "click-right": function ($event) {
                                            return _vm.popupSubmit("zcht", {
                                              label: "contractName",
                                              value: "contractId",
                                            })
                                          },
                                        },
                                      }),
                                      _c("van-search", {
                                        attrs: {
                                          clearable: "",
                                          shape: "round",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.pickerSearch(
                                              $event,
                                              _vm.zcht,
                                              "projectName"
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.zcht.filterText,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.zcht,
                                              "filterText",
                                              $$v
                                            )
                                          },
                                          expression: "zcht.filterText",
                                        },
                                      }),
                                      _c("van-picker", {
                                        ref: "zcht",
                                        attrs: {
                                          "value-key": "projectName",
                                          columns: _vm.zcht.filteredData,
                                        },
                                        on: {
                                          cancel: function ($event) {
                                            _vm.zcht.show = false
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4195594720
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("van-field", {
            directives: [
              {
                name: "f-show",
                rawName: "v-f-show",
                value: "zmlx",
                expression: "'zmlx'",
              },
            ],
            attrs: {
              "input-align": "right",
              name: "zmlx",
              required: _vm.isRequired("zmlx"),
              rules: _vm.getRules("zmlx"),
              label: "账套类型",
              placeholder: "请选择账套类型",
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return [
                    _vm.isDisabled("zmlx")
                      ? _c("view-item", {
                          attrs: { showLabel: _vm.formData.zmlx },
                        })
                      : _c(
                          "van-checkbox-group",
                          {
                            staticStyle: { display: "flex" },
                            attrs: { "checked-color": "rgb(255,218,62)" },
                            model: {
                              value: _vm.formData.zmlx,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "zmlx", $$v)
                              },
                              expression: "formData.zmlx",
                            },
                          },
                          [
                            _c(
                              "van-checkbox",
                              {
                                staticStyle: { "margin-right": "10px" },
                                attrs: { name: "管理账套" },
                              },
                              [_vm._v("管理账套")]
                            ),
                            _c(
                              "van-checkbox",
                              { attrs: { name: "核算账套" } },
                              [_vm._v("核算账套")]
                            ),
                          ],
                          1
                        ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "van-cell-group",
            { staticClass: "m-t-20" },
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sfygz",
                    expression: "'sfygz'",
                  },
                ],
                attrs: {
                  center: "",
                  "input-align": "right",
                  required: _vm.isRequired("sfygz"),
                  name: "sfygz",
                  rules: _vm.getRules("sfygz"),
                  label: "是否有挂账",
                  placeholder: "是否有挂账",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _vm.isDisabled("sfygz")
                          ? _c("view-item", {
                              attrs: { value: _vm.formData.sfygz },
                            })
                          : _c(
                              "van-radio-group",
                              {
                                attrs: { direction: "horizontal" },
                                model: {
                                  value: _vm.formData.sfygz,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "sfygz", $$v)
                                  },
                                  expression: "formData.sfygz",
                                },
                              },
                              [
                                _c("van-radio", { attrs: { name: "无" } }, [
                                  _vm._v("无"),
                                ]),
                                _c("van-radio", { attrs: { name: "有" } }, [
                                  _vm._v("有"),
                                ]),
                              ],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.sfygz,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sfygz", $$v)
                  },
                  expression: "formData.sfygz",
                },
              }),
              _vm.formData.sfygz === "有"
                ? _c("van-field", {
                    directives: [
                      {
                        name: "f-show",
                        rawName: "v-f-show",
                        value: "gzje",
                        expression: "'gzje'",
                      },
                    ],
                    attrs: {
                      disabled: _vm.isDisabled("gzje"),
                      type: "number",
                      name: "gzje",
                      rules: _vm.getRules("gzje"),
                      required: _vm.isRequired("gzje"),
                      maxlength: 10,
                      placeholder: "请输入挂账金额",
                      label: "挂账金额",
                      "input-align": "right",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.formatToTwoDecimals(_vm.formData, "gzje")
                      },
                    },
                    model: {
                      value: _vm.formData.gzje,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "gzje", $$v)
                      },
                      expression: "formData.gzje",
                    },
                  })
                : _vm._e(),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ckje",
                    expression: "'ckje'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("ckje"),
                  type: "number",
                  name: "ckje",
                  rules: _vm.getRules("ckje"),
                  required: _vm.isRequired("ckje"),
                  maxlength: 10,
                  placeholder: "请输入出款金额",
                  label: "出款金额",
                  "input-align": "right",
                },
                on: {
                  change: function ($event) {
                    return _vm.formatToTwoDecimals(_vm.formData, "ckje")
                  },
                },
                model: {
                  value: _vm.formData.ckje,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ckje", $$v)
                  },
                  expression: "formData.ckje",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "zffsmxb",
                  expression: "'zffsmxb'",
                },
              ],
            },
            [
              _c(
                "div",
                { staticClass: "font-32 font-weight-500 cor-00 m-t-26 m-b-26" },
                [_vm._v("财务出款")]
              ),
              _vm._l(_vm.formData.zffsmxb, function (item, index) {
                return _c(
                  "van-cell-group",
                  { key: index, staticClass: "b-r-10 m-t-20" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "p-b-20",
                        staticStyle: { "border-bottom": "1px solid #EBEBEB" },
                      },
                      [
                        _c(
                          "van-row",
                          { attrs: { type: "flex", align: "center" } },
                          [
                            _c("van-col", { attrs: { span: 22 } }, [
                              _c("img", {
                                staticClass: "w-5 h-28",
                                attrs: {
                                  src: `${_vm.image_base_url}/icon_line.png`,
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "cor-33 font-weight-500 font-28 m-l-16",
                                },
                                [_vm._v(_vm._s(`明细${index + 1}`))]
                              ),
                            ]),
                            _vm.isShowIcon("zffsmxb")
                              ? _c(
                                  "van-col",
                                  {
                                    attrs: { span: 2 },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeItem(index, "zffsmxb")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "w-30 h-30",
                                      attrs: {
                                        src: `${_vm.image_base_url}/shoppingDel.png`,
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "fkzh",
                          expression: "'fkzh'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "fkzh",
                        rules: _vm.getRules("fkzh"),
                        required: _vm.isRequired("fkzh"),
                        value: item.fkzh,
                        label: "付款账户",
                        placeholder: "请选择付款账户",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.fkzh,
                                    placeholder: "请选择付款账户",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.fkzh.show,
                                        index,
                                        "fkzh"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.fkzh.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.fkzh.show, index, $$v)
                                      },
                                      expression: "fkzh.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择付款账户",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.fkzh.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.fkzhSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.fkzh,
                                            "name"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.fkzh.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.fkzh, "filterText", $$v)
                                        },
                                        expression: "fkzh.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `fkzhPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.fkzh.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.fkzh.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zffs",
                          expression: "'zffs'",
                        },
                      ],
                      attrs: {
                        "input-align": "right",
                        name: "zffs",
                        rules: _vm.getRules("zffs"),
                        required: _vm.isRequired("zffs"),
                        value: item.zffs,
                        label: "支付方式",
                        placeholder: "请选择支付方式",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function () {
                              return [
                                _c("view-item", {
                                  attrs: {
                                    value: item.zffs,
                                    placeholder: "请选择支付方式",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.popupShow(
                                        _vm.zffs.show,
                                        index,
                                        "zffs"
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "van-popup",
                                  {
                                    attrs: { position: "bottom" },
                                    model: {
                                      value: _vm.zffs.show[index],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.zffs.show, index, $$v)
                                      },
                                      expression: "zffs.show[index]",
                                    },
                                  },
                                  [
                                    _c("van-nav-bar", {
                                      attrs: {
                                        title: "选择支付方式",
                                        "left-text": "取消",
                                        "right-text": "确定",
                                      },
                                      on: {
                                        "click-left": function ($event) {
                                          return _vm.popupHidden(
                                            _vm.zffs.show,
                                            index
                                          )
                                        },
                                        "click-right": function ($event) {
                                          return _vm.zffsSubmit(item, index)
                                        },
                                      },
                                    }),
                                    _c("van-search", {
                                      attrs: { clearable: "", shape: "round" },
                                      on: {
                                        input: function ($event) {
                                          return _vm.pickerSearch(
                                            $event,
                                            _vm.zffs,
                                            "name"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.zffs.filterText,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.zffs, "filterText", $$v)
                                        },
                                        expression: "zffs.filterText",
                                      },
                                    }),
                                    _c("van-picker", {
                                      ref: `zffsPicker_${index}`,
                                      refInFor: true,
                                      attrs: {
                                        "value-key": "name",
                                        columns: _vm.zffs.filteredData,
                                      },
                                      on: {
                                        cancel: function ($event) {
                                          _vm.zffs.show = false
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                    _c(
                      "van-cell-group",
                      { staticClass: "m-t-20" },
                      [
                        _c("van-field", {
                          directives: [
                            {
                              name: "f-show",
                              rawName: "v-f-show",
                              value: "sfygz",
                              expression: "'sfygz'",
                            },
                          ],
                          attrs: {
                            center: "",
                            "input-align": "right",
                            required: _vm.isRequired("sfygz"),
                            name: "zjlx",
                            rules: _vm.getRules("sfygz"),
                            label: "资金流向",
                            placeholder: "请选择资金流向",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function () {
                                  return [
                                    _vm.isDisabled("sfygz")
                                      ? _c("view-item", {
                                          attrs: { value: item.zjlx },
                                        })
                                      : _c(
                                          "van-radio-group",
                                          {
                                            attrs: { direction: "horizontal" },
                                            model: {
                                              value: item.zjlx,
                                              callback: function ($$v) {
                                                _vm.$set(item, "zjlx", $$v)
                                              },
                                              expression: "item.zjlx",
                                            },
                                          },
                                          [
                                            _c(
                                              "van-radio",
                                              { attrs: { name: "收入" } },
                                              [_vm._v("收入")]
                                            ),
                                            _c(
                                              "van-radio",
                                              { attrs: { name: "支出" } },
                                              [_vm._v("支出")]
                                            ),
                                          ],
                                          1
                                        ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: item.zjlx,
                            callback: function ($$v) {
                              _vm.$set(item, "zjlx", $$v)
                            },
                            expression: "item.zjlx",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("van-field", {
                      directives: [
                        {
                          name: "f-show",
                          rawName: "v-f-show",
                          value: "zfmxje",
                          expression: "'zfmxje'",
                        },
                      ],
                      attrs: {
                        disabled: _vm.isDisabled("zfmxje"),
                        type: "number",
                        name: "zfmxje",
                        rules: _vm.getRules("zfmxje"),
                        required: _vm.isRequired("zfmxje"),
                        maxlength: 10,
                        placeholder: "请输入支付金额",
                        label: "支付金额",
                        "input-align": "right",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.formatToTwoDecimals(item, "zfmxje")
                        },
                        change: function ($event) {
                          return _vm.changeZffsmxb(item)
                        },
                      },
                      model: {
                        value: item.zfmxje,
                        callback: function ($$v) {
                          _vm.$set(item, "zfmxje", $$v)
                        },
                        expression: "item.zfmxje",
                      },
                    }),
                  ],
                  1
                )
              }),
              !_vm.isDisabled("zffsmxb")
                ? _c(
                    "van-row",
                    [
                      _c("van-col", { attrs: { span: 12 } }),
                      _c(
                        "van-col",
                        { attrs: { span: 12 } },
                        [
                          _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加出款明细",
                            },
                            on: { click: _vm.addFKItem },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "f-show",
                  rawName: "v-f-show",
                  value: "relativeFlow",
                  expression: "'relativeFlow'",
                },
              ],
            },
            [
              _c(
                "van-row",
                {
                  staticClass: "m-t-26 m-b-26",
                  attrs: { type: "flex", align: "center" },
                },
                [
                  _c("van-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "font-32 font-weight-500 cor-00" },
                      [_vm._v("关联流程")]
                    ),
                  ]),
                  _c(
                    "van-col",
                    { attrs: { span: 12 } },
                    [
                      !_vm.isDisabled("relativeFlow")
                        ? _c("van-button", {
                            staticClass: "width-100",
                            attrs: {
                              icon: "add-o",
                              round: "",
                              "native-type": "button",
                              color: "#FFDA3E",
                              text: "添加审批单",
                            },
                            on: { click: _vm.addSpd },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formData.relativeFlow.length === 0
                ? _c("van-cell-group", { staticClass: "text-center p-20" }, [
                    _c("img", {
                      staticClass: "w-300 h-300",
                      attrs: { src: `${_vm.image_base_url}/null.png` },
                    }),
                    _c("div", { staticClass: "font-24 cor-8B m-t-20" }, [
                      _vm._v("暂无关联流程，请点击“添加审批单”关联~"),
                    ]),
                  ])
                : _vm._l(_vm.formData.relativeFlow, function (item, index) {
                    return _c(
                      "van-cell-group",
                      { key: index, staticClass: "b-r-10 m-t-20 p-20" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex col-center row-between" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                              },
                              [_vm._v(" " + _vm._s(item.title) + " ")]
                            ),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "f-show",
                                    rawName: "v-f-show",
                                    value: "relativeFlow",
                                    expression: "'relativeFlow'",
                                  },
                                ],
                                staticClass:
                                  "font-26 bg-FFFAEC cor-F8B91A p-l-10 p-r-10 p-b-6 p-t-6 border-7",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeItem(index, "relativeFlow")
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-30 h-30",
                                  attrs: {
                                    src: `${_vm.image_base_url}/shoppingDel.png`,
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("流程状态"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.businessStatusName) + " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("申请时间"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.startTime
                                          ? _vm
                                              .moment(item.startTime)
                                              .format("YYYY-MM-DD")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("完成时间"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.endTime
                                          ? _vm
                                              .moment(item.endTime)
                                              .format("YYYY-MM-DD")
                                          : ""
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "van-row",
                          {
                            staticClass: "m-t-10",
                            attrs: { type: "flex", align: "center" },
                          },
                          [
                            _c("van-col", { attrs: { span: "10" } }, [
                              _c("div", { staticClass: "cor-88 font-30" }, [
                                _vm._v("摘要"),
                              ]),
                            ]),
                            _c("van-col", { attrs: { span: "14" } }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cor-33 font-30 van-multi-ellipsis--l3",
                                },
                                [_vm._v(" " + _vm._s(item.summary) + " ")]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
            ],
            2
          ),
        ],
        2
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      _c("van-notice-bar", {
        attrs: {
          scrollable: "",
          text: "流程审批须知：请务必留意，审批流程的确定需依据成本归属部门进行。即，成本归属于哪个部门，则需由该部门的相关人员进行审批。",
        },
      }),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            attrs: {
              actCurrentNode: _vm.processData.actCurrentNode || "",
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            attrs: {
              processData: _vm.processData,
              formData: _vm.formData,
              formItemMap: _vm.formItemMap,
            },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-35", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("relativeFlow", {
        attrs: { show: _vm.relativeFlow.show },
        on: {
          finish: _vm.relativeFlowFinish,
          close: function ($event) {
            _vm.relativeFlow.show = false
          },
        },
      }),
      _c("account", {
        attrs: { show: _vm.account.show },
        on: {
          finish: _vm.accountFinish,
          close: function ($event) {
            _vm.account.show = false
          },
        },
      }),
      _c("imprest", {
        attrs: { show: _vm.imprest.show },
        on: {
          finish: _vm.imprestFinish,
          close: function ($event) {
            _vm.imprest.show = false
          },
        },
      }),
      _c("invoice", {
        ref: "invoice",
        attrs: {
          processInstanceId: _vm.processInstanceId,
          show: _vm.invoice.show,
        },
        on: { close: _vm.invoiceClose, success: _vm.invoiceSuccess },
      }),
      _c(
        "van-popup",
        {
          staticStyle: {
            "max-height": "70%",
            overflow: "auto",
            width: "calc(100% - 20px)",
          },
          model: {
            value: _vm.PdfPreviewShow,
            callback: function ($$v) {
              _vm.PdfPreviewShow = $$v
            },
            expression: "PdfPreviewShow",
          },
        },
        [
          _c("PdfPreview", {
            ref: "PdfPreviewPop",
            attrs: { "pdf-url": _vm.PdfPreviewPopFilePath },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }